exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ToastContainer_toast_container__2ncxN {\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 16px;\n  pointer-events: none; }\n\n.ToastContainer_toast__1Bgc5 {\n  width: 280px;\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 16px;\n  margin: 8px;\n  white-space: pre-wrap;\n  pointer-events: auto;\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", \"Consolas\", \"source-code-pro\", monospace; }\n  .ToastContainer_toast__1Bgc5.ToastContainer_success__GvDck {\n    border-color: #009600;\n    background-color: rgba(0, 120, 0, 0.8); }\n  .ToastContainer_toast__1Bgc5.ToastContainer_error__357Qi {\n    border-color: #960000;\n    background-color: rgba(120, 0, 0, 0.8); }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"toast_container": "ToastContainer_toast_container__2ncxN",
	"toast": "ToastContainer_toast__1Bgc5",
	"success": "ToastContainer_success__GvDck",
	"error": "ToastContainer_error__357Qi"
};